import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Counter } from '../_models/counter';

@Injectable({
  providedIn: 'root'
})
export class CounterService {
  baseUrl = environment.apiUrl;

  constructor(private http: HttpClient) {}
  getCounter(module): Observable<Counter> {
    return this.http.get<Counter>(this.baseUrl + 'counter/' + module);
  }
}
